import { memo, type PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  url: string;
  openInNewTab?: boolean;
}>;

export const LinkWrapper = memo(
  ({ children, url, openInNewTab = true }: Props) => (
    <a
      className="size-full text-foreground"
      href={url}
      rel="noopener noreferrer"
      target={openInNewTab ? '_blank' : undefined}
    >
      {children}
    </a>
  )
);
